import { render, staticRenderFns } from "./FleetResources.vue?vue&type=template&id=30537f34&"
import script from "./FleetResources.vue?vue&type=script&lang=js&"
export * from "./FleetResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports